module.exports = __webpack_public_path__ + "static/media/PhoneOutline.670d51bd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/svgs/PhoneOutline.svg
// module id = 386
// module chunks = 0